import { grpcClientFactory } from './grpcClientFactory';
function protoBreakdownToTs(item) {
    return {
        key: item.getKey() || '',
        title: item.getTitle() || '',
        color: item.getColor() || '',
        description: item.getDescription() || '',
        percent: item.getPercent() || 0,
    };
}
class PolygonStatsService {
    createAuthenticatedClient() {
        return grpcClientFactory.createAuthenticatedUserProjectsClient({ enableCompression: true });
    }
    async calculatePolygonStatistics(request) {
        const sessionId = localStorage.getItem('landscope_session_id');
        const sessionToken = localStorage.getItem('landscope_session_token');
        if (!sessionId || !sessionToken) {
            throw new Error('User must be authenticated');
        }
        return new Promise((resolve, reject) => {
            try {
                const Req = proto.landscope.mapviewer.v1.CalculatePolygonStatisticsRequest;
                const grpcReq = new Req();
                grpcReq.setProjectId(request.projectId);
                grpcReq.setPolygonGeojson(request.polygonGeojson);
                grpcReq.setAreaM2(request.areaM2);
                const client = this.createAuthenticatedClient();
                const metadata = { 'authorization': `Bearer ${sessionId}|${sessionToken}` };
                client.calculatePolygonStatistics(grpcReq, metadata, (err, resp) => {
                    if (err) {
                        reject(new Error(`Failed to calculate polygon statistics: ${err.message}`));
                        return;
                    }
                    if (!resp) {
                        reject(new Error('No response received'));
                        return;
                    }
                    resolve({
                        maxHeightM: resp.getMaxHeightM() || 0,
                        minHeightM: resp.getMinHeightM() || 0,
                        altitudeStdDev: resp.getAltitudeStdDev() || 0,
                        areaM2: resp.getAreaM2() || 0,
                        hemisphere: resp.getHemisphere() || '',
                        aspectBreakdown: (resp.getAspectBreakdownList() || []).map(protoBreakdownToTs),
                        slopeBreakdown: (resp.getSlopeBreakdownList() || []).map(protoBreakdownToTs),
                        elevationBreakdown: (resp.getElevationBreakdownList() || []).map(protoBreakdownToTs),
                        geomorphonsBreakdown: (resp.getGeomorphonsBreakdownList() || []).map(protoBreakdownToTs),
                    });
                });
            }
            catch (e) {
                reject(new Error(`Failed to calculate polygon statistics: ${e}`));
            }
        });
    }
}
export const polygonStatsService = new PolygonStatsService();
